(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oz-glass-cart-page"] && !Shopify.designMode) return;
  try {
    
  // Quantité et retrait sans quitter la page.
  //
  // Le contenu est re-rendu par l'API de rendu de section : les prix restent
  // formatés par le filtre `money` de Liquid, qui connaît la devise et le
  // format de la boutique. Les recalculer en JavaScript, c'est se tromper de
  // séparateur décimal un jour ou l'autre.
  (function () {
    function brancher(racine) {
      if (racine.dataset.ozCpLie) return;
      racine.dataset.ozCpLie = '1';

      var sectionId = racine.getAttribute('data-section-id');

      var partage = racine.querySelector('[data-oz-cp-share]');
      if (partage && navigator.share) {
        partage.hidden = false;
        partage.addEventListener('click', function () {
          navigator.share({ title: document.title, url: location.href }).catch(function () {});
        });
      }

      var edit = racine.querySelector('[data-oz-cp-edit]');
      if (edit) {
        edit.addEventListener('click', function () {
          var actif = racine.classList.toggle('is-editing');
          edit.setAttribute('aria-pressed', actif ? 'true' : 'false');
        });
      }

      function rafraichir() {
        var inner = racine.querySelector('[data-oz-cp-inner]');
        // SURTOUT PAS d’en-tete `Accept: application/json` ici : sur /cart,
        // Shopify repond alors avec le PANIER en JSON au lieu des sections
        // rendues, et la mise a jour retombe sur un rechargement complet.
        return fetch(location.pathname + '?sections=' + sectionId)
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var html = data[sectionId];
            if (!html) { location.reload(); return; }
            var frais = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-oz-cp-inner]');
            if (!frais) { location.reload(); return; }
            // On remplace le seul contenu : le conteneur garde sa classe
            // `is-editing`, donc le mode modification survit à la mise à jour.
            inner.replaceWith(frais);
          });
      }

      function changer(cle, quantite) {
        var inner = racine.querySelector('[data-oz-cp-inner]');
        inner.setAttribute('aria-busy', 'true');
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: cle, quantity: quantite })
        })
          .then(function () { return rafraichir(); })
          .catch(function () { location.reload(); })
          .then(function () {
            var maj = racine.querySelector('[data-oz-cp-inner]');
            if (maj) maj.removeAttribute('aria-busy');
            // L'en-tête du site porte un compteur : il doit suivre.
            document.dispatchEvent(new CustomEvent('oz:cart:changed'));
          });
      }

      // Délégation : le contenu est remplacé à chaque mise à jour, des
      // écouteurs posés sur les boutons seraient perdus au premier changement.
      racine.addEventListener('click', function (e) {
        var ligne = e.target.closest('[data-oz-cp-line]');
        if (!ligne) return;
        var cle = ligne.getAttribute('data-oz-cp-line');

        if (e.target.closest('[data-oz-cp-remove]')) { changer(cle, 0); return; }

        var pas = e.target.closest('[data-oz-cp-qty]');
        if (!pas) return;
        var sortie = ligne.querySelector('[data-oz-cp-n]');
        var n = parseInt(sortie ? sortie.textContent : '1', 10);
        if (isNaN(n)) n = 1;
        changer(cle, Math.max(0, n + parseInt(pas.getAttribute('data-oz-cp-qty'), 10)));
      });
    }

    function init() {
      var tous = document.querySelectorAll('[data-oz-cp]');
      for (var i = 0; i < tous.length; i++) brancher(tous[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oz-glass-contact-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Prénom + nom → champ caché « name », pour que l'e-mail reçu par le
    // marchand porte un expéditeur nommé. Délégué au document : les sections
    // rechargées par l'éditeur de thème sont couvertes sans ré-attacher.
    document.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest ? e.target.closest('.oz-cf__form') : null;
      if (!form) return;
      var first = form.querySelector('[data-oz-cf-first]');
      var last = form.querySelector('[data-oz-cf-last]');
      var name = form.querySelector('[data-oz-cf-name]');
      if (!name) return;
      var full = ((first ? first.value : '') + ' ' + (last ? last.value : '')).trim();
      name.value = full;
      // Un champ vide ne doit pas arriver dans l'e-mail sous la forme « name: ».
      if (!full) name.disabled = true;
    });

    // Après envoi, Shopify recharge la page : on amène le message de
    // confirmation (ou d'erreur) sous les yeux au lieu de laisser le
    // visiteur en haut de page, sans savoir si ça a marché.
    function focusNote() {
      var note = document.querySelector('[data-oz-cf-focus]');
      if (!note) return;
      note.scrollIntoView({ block: 'center' });
      note.focus({ preventScroll: true });
    }
    // Bandeau de logos : deux copies suffisent quand la liste est plus large
    // que le cadre. Sinon (trois logos dans une colonne de 480 px, par
    // exemple) on clone jusqu'à couvrir deux fois la largeur, et le
    // déplacement d'un cycle devient la largeur exacte d'une copie.
    function setupMarquee(mq) {
      if (mq.dataset.ozCfMqReady) return;
      var track = mq.querySelector('.oz-cf__mq-track');
      var first = mq.querySelector('.oz-cf__mq-copy');
      if (!track || !first) return;
      var copyW = first.getBoundingClientRect().width;
      var frameW = mq.getBoundingClientRect().width;
      if (!copyW || !frameW) return;
      mq.dataset.ozCfMqReady = '1';
      while (track.scrollWidth < frameW * 2 + copyW && track.children.length < 12) {
        var clone = first.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }
      track.style.setProperty('--cf-mq-shift', copyW + 'px');
    }

    function initMarquees() {
      var all = document.querySelectorAll('[data-oz-cf-mq]');
      for (var i = 0; i < all.length; i++) setupMarquee(all[i]);
    }

    function init() {
      focusNote();
      initMarquees();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    // Les polices arrivent après le DOM : une largeur mesurée trop tôt serait
    // fausse pour les mots-marques en texte. On remesure une fois chargées.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        var all = document.querySelectorAll('[data-oz-cf-mq]');
        for (var i = 0; i < all.length; i++) {
          var first = all[i].querySelector('.oz-cf__mq-copy');
          var track = all[i].querySelector('.oz-cf__mq-track');
          if (first && track && all[i].dataset.ozCfMqReady) {
            track.style.setProperty('--cf-mq-shift', first.getBoundingClientRect().width + 'px');
          }
        }
      });
    }
    document.addEventListener('shopify:section:load', initMarquees);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oz-glass-gate"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function retenir(g) {
      if (g.hasAttribute('data-oz-gate-design')) return;
      var key = g.getAttribute('data-oz-gate-key');
      var freq = g.getAttribute('data-oz-gate-freq');
      try {
        if (freq === 'session') sessionStorage.setItem(key, '1');
        else if (freq === 'day') localStorage.setItem(key, String(Date.now()));
        else if (freq === 'once') localStorage.setItem(key, '1');
      } catch (e) { /* stockage indisponible : elle reviendra, tant pis */ }
    }

    function fermer(g, sansRetenir) {
      if (g.hidden || g.classList.contains('is-leaving')) return;
      if (!sansRetenir) retenir(g);
      var fait = false;
      var fin = function () {
        if (fait) return;
        fait = true;
        g.hidden = true;
        g.classList.remove('is-leaving');
        document.documentElement.classList.remove('oz-gate-open');
        if (g.__ozRetour && g.__ozRetour.focus) g.__ozRetour.focus({ preventScroll: true });
      };
      if (reduit) { fin(); return; }
      g.classList.add('is-leaving');
      g.addEventListener('transitionend', fin, { once: true });
      // filet : si la transition n'émet rien (onglet caché…), on termine quand même
      setTimeout(fin, (parseInt(g.getAttribute('data-oz-gate-dur'), 10) || 900) + 300);
    }

    function ouvrir(g) {
      g.__ozRetour = document.activeElement;
      g.classList.remove('is-leaving');
      g.hidden = false;
      document.documentElement.classList.add('oz-gate-open');
      var b = g.querySelector('[data-oz-gate-go]');
      if (b) b.focus({ preventScroll: true });
    }

    function brancher(g) {
      if (g.dataset.ozGateLie) return;
      g.dataset.ozGateLie = '1';
      g.addEventListener('click', function (e) {
        if (e.target.closest('[data-oz-gate-go]')) fermer(g);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !g.hidden) fermer(g);
      });
      if (!g.hidden) {
        var b = g.querySelector('[data-oz-gate-go]');
        if (b) b.focus({ preventScroll: true });
      }
    }

    function init() {
      var tous = document.querySelectorAll('[data-oz-gate]');
      for (var i = 0; i < tous.length; i++) brancher(tous[i]);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();

    // Éditeur de thème : la porte se montre quand on sélectionne la
    // section, se range quand on la quitte — sans rien mémoriser.
    // Un réglage modifié re-rend la section (masquée par défaut) alors que
    // le marchand est dessus : on la rouvre pour qu'il voie son changement.
    document.addEventListener('shopify:section:load', function (e) {
      init();
      var g = e.target && e.target.querySelector ? e.target.querySelector('[data-oz-gate]') : null;
      if (g) ouvrir(g);
    });
    document.addEventListener('shopify:section:select', function (e) {
      var g = e.target && e.target.querySelector ? e.target.querySelector('[data-oz-gate]') : null;
      if (g) { brancher(g); ouvrir(g); }
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      var g = e.target && e.target.querySelector ? e.target.querySelector('[data-oz-gate]') : null;
      if (g) fermer(g, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oz-glass-grid"] && !Shopify.designMode) return;
  try {
    
  // Filtres par tag. Tout se joue sur les produits déjà rendus : aucun
  // aller-retour serveur, donc aucune attente perceptible.
  (function () {
    function brancher(racine) {
      if (racine.dataset.ozPgLie) return;
      racine.dataset.ozPgLie = '1';

      var chips = racine.querySelectorAll('[data-oz-pg-filter]');
      var cartes = racine.querySelectorAll('[data-oz-pg-card]');
      var vide = racine.querySelector('[data-oz-pg-none]');
      if (!chips.length) return;

      function appliquer(tag) {
        var visibles = 0;
        for (var i = 0; i < cartes.length; i++) {
          var tags = (cartes[i].getAttribute('data-tags') || '').split('|');
          var garde = !tag || tags.indexOf(tag) !== -1;
          // `hidden` plutôt que display:none en ligne : l'état reste lisible
          // dans le DOM et la carte sort aussi de l'ordre de tabulation.
          cartes[i].hidden = !garde;
          if (garde) visibles++;
        }
        if (vide) vide.hidden = visibles > 0;
      }

      for (var i = 0; i < chips.length; i++) {
        (function (chip) {
          chip.addEventListener('click', function () {
            for (var j = 0; j < chips.length; j++) {
              var actif = chips[j] === chip;
              chips[j].classList.toggle('is-on', actif);
              chips[j].setAttribute('aria-selected', actif ? 'true' : 'false');
            }
            appliquer(chip.getAttribute('data-oz-pg-filter'));
          });
        })(chips[i]);
      }
    }

    function init() {
      var tous = document.querySelectorAll('[data-oz-pg]');
      for (var i = 0; i < tous.length; i++) brancher(tous[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oz-glass-hd"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Compte à rebours : une horloge par seconde pour toutes les pastilles.
       Format HH:MM:SS ; au-delà d'un jour, « 2j 04:15:00 ». */
    function deuxChiffres(n) { return (n < 10 ? '0' : '') + n; }
    function rendre(el, now) {
      var fin = el.__ozUntil;
      if (!fin) return;
      var txt = el.querySelector('.oz-hd__pill-txt') || el;
      var reste = Math.floor((fin - now) / 1000);
      if (reste <= 0) {
        txt.textContent = el.getAttribute('data-ended') || '00:00:00';
        el.classList.add('is-over');
        return;
      }
      var j = Math.floor(reste / 86400);
      var h = Math.floor((reste % 86400) / 3600);
      var m = Math.floor((reste % 3600) / 60);
      var sec = reste % 60;
      txt.textContent = (j > 0 ? j + 'j ' : '') + deuxChiffres(h) + ' : ' + deuxChiffres(m) + ' : ' + deuxChiffres(sec);
    }
    var pilules = [];
    var horloge = 0;
    function tic() {
      var now = Date.now();
      for (var i = 0; i < pilules.length; i++) rendre(pilules[i], now);
    }
    function brancherPilule(el) {
      if (el.dataset.ozHdLie) return;
      el.dataset.ozHdLie = '1';
      var d = new Date(el.getAttribute('data-oz-hd-until'));
      if (isNaN(d.getTime())) { el.querySelector('.oz-hd__pill-txt').textContent = el.getAttribute('data-ended') || ''; return; }
      el.__ozUntil = d.getTime();
      pilules.push(el);
      rendre(el, Date.now());
      if (!horloge) horloge = setInterval(tic, 1000);
    }

    /* Favoris : même liste (localStorage « oz:fav ») que la fiche produit. */
    var CLE = 'oz:fav';
    function lire() {
      try { return JSON.parse(localStorage.getItem(CLE) || '[]') || []; } catch (e) { return []; }
    }
    function ecrire(liste) {
      try { localStorage.setItem(CLE, JSON.stringify(liste)); } catch (e) { /* stockage indisponible */ }
    }
    function peindre(btn, on) {
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = on ? btn.getAttribute('data-label-remove') : btn.getAttribute('data-label-add');
      if (lbl) btn.setAttribute('aria-label', lbl);
    }
    function brancherFav(btn) {
      if (btn.dataset.ozFavLie) return;
      btn.dataset.ozFavLie = '1';
      var handle = btn.getAttribute('data-handle');
      if (!handle) return;
      peindre(btn, lire().indexOf(handle) !== -1);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var liste = lire();
        var i = liste.indexOf(handle);
        if (i === -1) liste.push(handle); else liste.splice(i, 1);
        ecrire(liste);
        peindre(btn, i === -1);
        btn.classList.remove('is-pop');
        void btn.offsetWidth;
        btn.classList.add('is-pop');
      });
    }

    function init() {
      var p = document.querySelectorAll('.oz-hd [data-oz-hd-until]');
      for (var i = 0; i < p.length; i++) brancherPilule(p[i]);
      var f = document.querySelectorAll('.oz-hd [data-oz-fav]');
      for (var j = 0; j < f.length; j++) brancherFav(f[j]);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oz-glass-hub"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // ---------- onglets : montrer / masquer les cartes déjà rendues ----------
    function brancherOnglets(racine) {
      var onglets = racine.querySelectorAll('[data-oz-hub-tab]');
      var cartes = racine.querySelectorAll('[data-oz-hub-card]');
      var vide = racine.querySelector('[data-oz-hub-none]');
      if (!onglets.length) return;

      function montrer(id) {
        var n = 0;
        for (var i = 0; i < cartes.length; i++) {
          var garde = cartes[i].getAttribute('data-oz-hub-card') === id;
          // `hidden` plutôt que display:none en ligne : l'état reste lisible
          // dans le DOM et la carte sort aussi de l'ordre de tabulation.
          cartes[i].hidden = !garde;
          if (garde) n++;
        }
        if (vide) vide.hidden = n > 0;
      }

      for (var i = 0; i < onglets.length; i++) {
        (function (o) {
          o.addEventListener('click', function () {
            for (var j = 0; j < onglets.length; j++) {
              var actif = onglets[j] === o;
              onglets[j].classList.toggle('is-on', actif);
              onglets[j].setAttribute('aria-selected', actif ? 'true' : 'false');
            }
            montrer(o.getAttribute('data-oz-hub-tab'));
          });
        })(onglets[i]);
      }
    }

    // ---------- carrousel : même mécanique que les témoignages ----------
    function brancherCarrousel(racine) {
      var car = racine.querySelector('[data-oz-hub-car]');
      if (!car) return;
      var piste = car.querySelector('[data-oz-hub-track]');
      var vue = car.querySelector('[data-oz-hub-viewport]');
      if (!piste || !vue) return;

      var total = piste.children.length;
      var points = car.querySelectorAll('[data-oz-hub-dot]');
      if (total < 2) return;

      var index = 0, minuteur = null;
      var delai = parseInt(car.getAttribute('data-oz-hub-auto'), 10);
      var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function ajusterHauteur() {
        var d = piste.children[index];
        if (d) piste.style.height = d.offsetHeight + 'px';
      }

      function montrer(n, sansRelance) {
        index = (n + total) % total;
        piste.style.transform = 'translateX(' + (-index * 100) + '%)';
        ajusterHauteur();
        for (var i = 0; i < points.length; i++) {
          var actif = i === index;
          points[i].classList.toggle('is-on', actif);
          points[i].setAttribute('aria-selected', actif ? 'true' : 'false');
        }
        if (!sansRelance) relancer();
      }

      function relancer() {
        if (!delai || reduit) return;
        clearTimeout(minuteur);
        minuteur = setTimeout(function () { montrer(index + 1); }, delai);
      }

      for (var i = 0; i < points.length; i++) {
        (function (p) {
          p.addEventListener('click', function () {
            montrer(parseInt(p.getAttribute('data-oz-hub-dot'), 10));
          });
        })(points[i]);
      }

      vue.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); montrer(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); montrer(index - 1); }
      });

      car.addEventListener('pointerenter', function () { clearTimeout(minuteur); });
      car.addEventListener('pointerleave', relancer);
      car.addEventListener('focusin', function () { clearTimeout(minuteur); });

      if (window.PointerEvent) {
        var actifGeste = false, verrou = false, pid = null, x0 = 0, y0 = 0, dx = 0;

        vue.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          actifGeste = true; verrou = false; pid = e.pointerId;
          x0 = e.clientX; y0 = e.clientY; dx = 0;
          clearTimeout(minuteur);
        });

        vue.addEventListener('pointermove', function (e) {
          if (!actifGeste || e.pointerId !== pid) return;
          var ddx = e.clientX - x0, ddy = e.clientY - y0;
          if (!verrou) {
            if (Math.abs(ddx) < 8 && Math.abs(ddy) < 8) return;
            // Un geste vertical appartient au défilement de la page.
            if (Math.abs(ddy) > Math.abs(ddx)) { actifGeste = false; return; }
            verrou = true;
            car.classList.add('is-dragging');
            try { vue.setPointerCapture(pid); } catch (err) { /* sans importance */ }
          }
          dx = ddx;
          piste.style.transform = 'translateX(' + (-index * 100 + (dx / vue.clientWidth) * 100) + '%)';
        });

        // Un glissement qui a vraiment bougé ne doit pas déclencher le lien
        // sous le doigt : on avale le clic qui suit.
        var finGeste = function (e) {
          if (!actifGeste || (pid !== null && e.pointerId !== pid)) return;
          var glissait = verrou;
          actifGeste = false; verrou = false; pid = null;
          car.classList.remove('is-dragging');
          if (!glissait) { relancer(); return; }
          var seuil = vue.clientWidth * 0.2;
          if (dx < -seuil) montrer(index + 1);
          else if (dx > seuil) montrer(index - 1);
          else montrer(index);
          var avaler = function (ev) { ev.preventDefault(); ev.stopPropagation(); };
          vue.addEventListener('click', avaler, { capture: true, once: true });
          setTimeout(function () { vue.removeEventListener('click', avaler, { capture: true }); }, 300);
        };
        vue.addEventListener('pointerup', finGeste);
        vue.addEventListener('pointercancel', finGeste);
      }

      montrer(0, true);
      relancer();
      window.addEventListener('resize', ajusterHauteur);
      window.addEventListener('load', ajusterHauteur);

      // Exposé pour l'éditeur de thème : cliquer un bloc « Vedette » dans
      // le panneau doit montrer SA diapositive, sinon on règle à l'aveugle.
      car.__ozMontrer = function (n) { clearTimeout(minuteur); montrer(n, true); };
    }

    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target && e.target.closest ? e.target.closest('.oz-hub__slide') : null;
      if (!slide) return;
      var car = slide.closest('[data-oz-hub-car]');
      if (!car || !car.__ozMontrer) return;
      var i = Array.prototype.indexOf.call(slide.parentNode.children, slide);
      if (i >= 0) car.__ozMontrer(i);
    });

    function brancher(racine) {
      if (racine.dataset.ozHubLie) return;
      racine.dataset.ozHubLie = '1';
      brancherOnglets(racine);
      brancherCarrousel(racine);
    }

    function init() {
      var tous = document.querySelectorAll('[data-oz-hub]');
      for (var i = 0; i < tous.length; i++) brancher(tous[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oz-glass-logo-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Deux copies suffisent quand la liste est plus large que le cadre.
    // Sinon on clone jusqu'à couvrir deux fois la largeur, et le déplacement
    // d'un cycle devient la largeur exacte d'une copie.
    function setup(mq) {
      if (mq.dataset.ozLbReady) return;
      var track = mq.querySelector('.oz-lb__track');
      var first = mq.querySelector('.oz-lb__copy');
      if (!track || !first) return;
      var copyW = first.getBoundingClientRect().width;
      var frameW = mq.getBoundingClientRect().width;
      if (!copyW || !frameW) return;
      mq.dataset.ozLbReady = '1';
      while (track.scrollWidth < frameW * 2 + copyW && track.children.length < 16) {
        var clone = first.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }
      track.style.setProperty('--lb-shift', copyW + 'px');
    }

    function remeasure() {
      var all = document.querySelectorAll('[data-oz-lb-mq]');
      for (var i = 0; i < all.length; i++) {
        var first = all[i].querySelector('.oz-lb__copy');
        var track = all[i].querySelector('.oz-lb__track');
        if (first && track && all[i].dataset.ozLbReady) {
          track.style.setProperty('--lb-shift', first.getBoundingClientRect().width + 'px');
        }
      }
    }

    function init() {
      var all = document.querySelectorAll('[data-oz-lb-mq]');
      for (var i = 0; i < all.length; i++) setup(all[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    // Les polices arrivent après le DOM : une largeur mesurée trop tôt serait
    // fausse pour les mots-marques en texte.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oz-glass-me"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Indicateur vertical : suit le défilement, et un clic sur un point
       amène le visuel. Le défilement lui-même est natif (scroll-snap). */
    function galerie(gal) {
      if (gal.dataset.ozMeLie) return;
      gal.dataset.ozMeLie = '1';
      /* Plein écran mobile : hauteur du visuel = écran − ce qu'il y a
         au-dessus (en-tête compris). Mesuré ici plutôt que deviné en CSS ;
         pas sur écran large, où la galerie est collante (sticky) et son
         rect ne dit plus rien de sa place dans le flux. AVANT le test des
         points : un produit à une seule photo n'en a pas, et il a quand
         même droit à son plein écran. */
      var mq = window.matchMedia('(max-width: 899px)');
      var rafTop = 0;
      function mesurer() {
        rafTop = 0;
        if (!mq.matches) return;
        var top = gal.getBoundingClientRect().top + (window.pageYOffset || 0);
        gal.style.setProperty('--me-top', Math.max(0, Math.round(top)) + 'px');
      }
      function remesurer() {
        if (!rafTop) rafTop = requestAnimationFrame(mesurer);
      }
      mesurer();
      window.addEventListener('resize', remesurer);
      window.addEventListener('load', remesurer);

      var track = gal.querySelector('.oz-me__track');
      var dots = gal.querySelectorAll('[data-oz-me-dot]');
      if (!track || !dots.length) return;
      var raf = 0;
      function peindre() {
        raf = 0;
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-on', k === i);
      }
      track.addEventListener('scroll', function () {
        if (!raf) raf = requestAnimationFrame(peindre);
      }, { passive: true });
      for (var k = 0; k < dots.length; k++) {
        (function (dot, idx) {
          dot.addEventListener('click', function () {
            track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
          });
        })(dots[k], k);
      }
      peindre();
    }

    /* Favoris : une liste de handles dans le navigateur du visiteur — même
       clé que la section swipe, un cœur posé ici se retrouve là-bas. */
    var CLE = 'oz:fav';
    function lire() {
      try { return JSON.parse(localStorage.getItem(CLE) || '[]') || []; } catch (e) { return []; }
    }
    function ecrire(liste) {
      try { localStorage.setItem(CLE, JSON.stringify(liste)); } catch (e) { /* stockage indisponible */ }
    }
    function peindreFav(btn, on) {
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = on ? btn.getAttribute('data-label-remove') : btn.getAttribute('data-label-add');
      if (lbl) btn.setAttribute('aria-label', lbl);
    }
    function favori(btn) {
      if (btn.dataset.ozFavLie) return;
      btn.dataset.ozFavLie = '1';
      var handle = btn.getAttribute('data-handle');
      if (!handle) return;
      peindreFav(btn, lire().indexOf(handle) !== -1);
      btn.addEventListener('click', function () {
        var liste = lire();
        var i = liste.indexOf(handle);
        if (i === -1) liste.push(handle); else liste.splice(i, 1);
        ecrire(liste);
        try { window.dispatchEvent(new Event('oz:fav')); } catch (e) { /* vieux navigateur */ }
        peindreFav(btn, i === -1);
        btn.classList.remove('is-pop');
        void btn.offsetWidth;
        btn.classList.add('is-pop');
      });
    }

    function init() {
      var g = document.querySelectorAll('[data-oz-me-gallery]');
      for (var i = 0; i < g.length; i++) galerie(g[i]);
      var f = document.querySelectorAll('.oz-me [data-oz-fav]');
      for (var j = 0; j < f.length; j++) favori(f[j]);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oz-glass-signup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Après envoi, Shopify recharge la page : on amène la confirmation (ou
    // l'erreur) sous les yeux au lieu de laisser le visiteur en haut de page.
    function focusNote() {
      var note = document.querySelector('[data-oz-nl-focus]');
      if (!note) return;
      note.scrollIntoView({ block: 'center' });
      note.focus({ preventScroll: true });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', focusNote);
    } else {
      focusNote();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oz-glass-swipe"]) return;
  try {
    
  (function () {
    // Favoris : une liste de handles dans le navigateur du visiteur. Pas de
    // compte requis, rien n'est envoyé — et ça survit au rechargement.
    var CLE = 'oz:fav';

    function lire() {
      try { return JSON.parse(localStorage.getItem(CLE) || '[]') || []; } catch (e) { return []; }
    }
    function ecrire(liste) {
      try { localStorage.setItem(CLE, JSON.stringify(liste)); } catch (e) { /* stockage indisponible */ }
    }

    function peindre(btn, on) {
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var lbl = on ? btn.getAttribute('data-label-remove') : btn.getAttribute('data-label-add');
      if (lbl) btn.setAttribute('aria-label', lbl);
    }

    function brancher(btn) {
      if (btn.dataset.ozFavLie) return;
      btn.dataset.ozFavLie = '1';
      var handle = btn.getAttribute('data-handle');
      if (!handle) return;
      peindre(btn, lire().indexOf(handle) !== -1);
      btn.addEventListener('click', function () {
        var liste = lire();
        var i = liste.indexOf(handle);
        if (i === -1) liste.push(handle); else liste.splice(i, 1);
        ecrire(liste);
        peindre(btn, i === -1);
        btn.classList.remove('is-pop');
        void btn.offsetWidth;
        btn.classList.add('is-pop');
      });
    }

    function init() {
      var tous = document.querySelectorAll('[data-oz-fav]');
      for (var i = 0; i < tous.length; i++) brancher(tous[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oz-glass-testimonial"] && !Shopify.designMode) return;
  try {
    
  // Carrousel de témoignages : pastilles, glissement au doigt, flèches du
  // clavier. Rien ne dépend d'une bibliothèque — le thème n'en charge aucune.
  (function () {
    function brancher(racine) {
      if (racine.dataset.ozTmoLie) return;
      racine.dataset.ozTmoLie = '1';

      var piste = racine.querySelector('[data-oz-tmo-track]');
      var vue = racine.querySelector('[data-oz-tmo-viewport]');
      if (!piste || !vue) return;

      var diapos = piste.children;
      var points = racine.querySelectorAll('[data-oz-tmo-dot]');
      var total = diapos.length;
      if (total < 2) return;

      var index = 0;
      var minuteur = null;
      var delai = parseInt(racine.getAttribute('data-oz-tmo-auto'), 10);
      var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function montrer(n, sansRelance) {
        index = (n + total) % total;
        piste.style.transform = 'translateX(' + (-index * 100) + '%)';
        for (var i = 0; i < points.length; i++) {
          var actif = i === index;
          points[i].classList.toggle('is-on', actif);
          points[i].setAttribute('aria-selected', actif ? 'true' : 'false');
        }
        if (!sansRelance) relancer();
      }

      function relancer() {
        if (!delai || reduit) return;
        clearTimeout(minuteur);
        minuteur = setTimeout(function () { montrer(index + 1); }, delai);
      }

      for (var i = 0; i < points.length; i++) {
        (function (p) {
          p.addEventListener('click', function () {
            montrer(parseInt(p.getAttribute('data-oz-tmo-dot'), 10));
          });
        })(points[i]);
      }

      vue.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); montrer(index + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); montrer(index - 1); }
      });

      // Le défilement automatique s'arrête dès qu'on interagit : reprendre
      // sous le doigt de quelqu'un qui lit est la pire chose à faire.
      racine.addEventListener('pointerenter', function () { clearTimeout(minuteur); });
      racine.addEventListener('pointerleave', relancer);
      racine.addEventListener('focusin', function () { clearTimeout(minuteur); });

      // --- glissement au doigt ---
      if (window.PointerEvent) {
        var actifGeste = false, verrou = false, pid = null, x0 = 0, y0 = 0, dx = 0;

        vue.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          actifGeste = true; verrou = false; pid = e.pointerId;
          x0 = e.clientX; y0 = e.clientY; dx = 0;
          clearTimeout(minuteur);
        });

        vue.addEventListener('pointermove', function (e) {
          if (!actifGeste || e.pointerId !== pid) return;
          var ddx = e.clientX - x0, ddy = e.clientY - y0;
          if (!verrou) {
            if (Math.abs(ddx) < 8 && Math.abs(ddy) < 8) return;
            // Verrou de direction : un geste vertical appartient au
            // défilement de la page, on ne le lui vole pas.
            if (Math.abs(ddy) > Math.abs(ddx)) { actifGeste = false; return; }
            verrou = true;
            racine.classList.add('is-dragging');
            try { vue.setPointerCapture(pid); } catch (err) { /* sans importance */ }
          }
          dx = ddx;
          var pct = (dx / vue.clientWidth) * 100;
          piste.style.transform = 'translateX(' + (-index * 100 + pct) + '%)';
        });

        var finGeste = function (e) {
          if (!actifGeste || (pid !== null && e.pointerId !== pid)) return;
          var glissait = verrou;
          actifGeste = false; verrou = false; pid = null;
          racine.classList.remove('is-dragging');
          if (!glissait) { relancer(); return; }
          // Un cinquième de la largeur suffit : au-delà, le geste devient
          // fatigant sur un téléphone tenu d'une main.
          var seuil = vue.clientWidth * 0.2;
          if (dx < -seuil) montrer(index + 1);
          else if (dx > seuil) montrer(index - 1);
          else montrer(index);
        };
        vue.addEventListener('pointerup', finGeste);
        vue.addEventListener('pointercancel', finGeste);
      }

      montrer(0, true);
      relancer();
    }

    function init() {
      var tous = document.querySelectorAll('[data-oz-tmo]');
      for (var i = 0; i < tous.length; i++) brancher(tous[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
